/**
 * This plugin runs actual Segment validation, but only in dev mode.
 */
export default defineNuxtPlugin({
  name: 'segment-validation',
  parallel: true,
  async setup() {
    if (!isMetaDev) {
      return
    }

    const { getSegmentViolations } = await import('~/utils/tracking/segment-validation')

    setSegmentValidator((eventName, payload) => {
      const violations = getSegmentViolations(eventName, payload)

      if (violations) {
        logViolation(eventName, violations, payload)
      }
    })
  },
})
